// @flow
import {pick} from 'lodash';
import {cookieOptions} from './cookieUtils';

import type {SearchRequest} from '@homeaway/search-url-parser';
import type {HapiCookieState} from './cookieUtils';

export const LOCATION_COOKIE = 'ha-state-prst';

export const locationDataFields = ['q'];

export type LocationQuery = {
    q?: string
};

export type LocationCookie = {
    lbsKeywords?: string,
    lastSearchUrl?: string
};

export const locationCookieDataFromQueryData = (
    query: LocationQuery,
    searchURL: string
): LocationCookie => ({
    lbsKeywords: query.q,
    lastSearchUrl: searchURL && decodeURIComponent(searchURL)
});

export const locationDataCookieFromSearchRequest = (
    searchRequest: SearchRequest,
    searchRequestURL: string
): HapiCookieState => {
    const queryLocationData = pick(searchRequest, locationDataFields);
    return {
        name: LOCATION_COOKIE,
        data: encodeURIComponent(
            JSON.stringify(
                locationCookieDataFromQueryData(
                    queryLocationData,
                    searchRequestURL
                )
            )
        ),
        options: cookieOptions
    };
};
